interface Props {
  statusCodes: Record<string, Record<string, number>> | null;
}

const TAG_ORDER = ['auth', 'crud', 'aggregation', 'llm', 'sse', 'untagged'];

function statusColor(status: string): string {
  const code = parseInt(status, 10);
  if (!Number.isFinite(code)) return 'text-gray-700';
  if (code >= 200 && code < 300) return 'text-emerald-700';
  if (code >= 300 && code < 400) return 'text-blue-700';
  if (code === 401 || code === 403) return 'text-amber-700';
  if (code === 429) return 'text-amber-800 font-semibold';
  if (code >= 400 && code < 500) return 'text-orange-700';
  if (code >= 500) return 'text-red-700 font-semibold';
  return 'text-gray-700';
}

export function StatusCodesTable({ statusCodes }: Props) {
  if (!statusCodes || Object.keys(statusCodes).length === 0) {
    return (
      <div className="text-xs text-gray-500 italic">
        Pas de breakdown disponible (run antérieur à la migration 087).
      </div>
    );
  }

  const tags = Object.keys(statusCodes).sort((a, b) => {
    const ai = TAG_ORDER.indexOf(a);
    const bi = TAG_ORDER.indexOf(b);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });

  return (
    <div className="space-y-2">
      {tags.map((tag) => {
        const byStatus = statusCodes[tag];
        const total = Object.values(byStatus).reduce((a, b) => a + b, 0);
        const sortedStatuses = Object.entries(byStatus).sort(([a], [b]) => a.localeCompare(b));
        return (
          <div key={tag} className="border border-gray-200 rounded-md overflow-hidden">
            <div className="bg-gray-50 px-3 py-1.5 flex items-center justify-between text-xs">
              <span className="font-medium text-gray-700 capitalize">{tag}</span>
              <span className="text-gray-500 tabular-nums">{total.toLocaleString('fr-FR')} reqs</span>
            </div>
            <div className="px-3 py-2 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-1 text-xs">
              {sortedStatuses.map(([status, count]) => {
                const pct = total > 0 ? (count * 100) / total : 0;
                return (
                  <div key={status} className="flex items-baseline justify-between gap-2">
                    <span className={`tabular-nums ${statusColor(status)}`}>{status}</span>
                    <span className="tabular-nums text-gray-700">
                      {count.toLocaleString('fr-FR')}{' '}
                      <span className="text-gray-400">({pct.toFixed(1)} %)</span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
